const MAP = {
  // shifts/status -> badge class
  ACTIVE: "badge-active", CONFIRMED: "badge-active", COMPLETED: "badge-active",
  SCHEDULED: "badge-pending", OPEN: "badge-pending", PENDING: "badge-pending", RECEIVED: "badge-pending",
  MISSED: "badge-alert", INCIDENT: "badge-alert", CRITICAL: "badge-alert", OVERDUE: "badge-overdue",
  EN_ROUTE: "badge-pending", ASSIGNED: "badge-pending", ON_SCENE: "badge-pending",
  RESOLVED: "badge-paid",
  PAID: "badge-paid", SENT: "badge-pending", DRAFT: "badge-off", VIEWED: "badge-pending",
  HIGH: "badge-alert", MEDIUM: "badge-pending", LOW: "badge-off",
  DAR: "badge-neutral", HOURLY: "badge-neutral", PASSDOWN: "badge-neutral",
  INCOMPLETE: "badge-alert",
};

export const StatusBadge = ({ status, label }) => {
  const cls = MAP[status] || "badge-off";
  return <span className={`badge ${cls}`} data-testid={`badge-${status}`}>{label || (status || "").replace(/_/g, " ")}</span>;
};
